import React, { Suspense, lazy } from "react"
// import ReactDOM from "react-dom"
import ReactDOM from "react-dom/client";

import './authServices/firebase/firebaseConfig'

import { Provider } from "react-redux"
import Spinner from "./components/@vuexy/spinner/Fallback-spinner"
import "./index.scss"
import { store } from "./redux/storeConfig/store"
import * as serviceWorker from "./serviceWorker"
import { Layout } from "./utility/context/Layout"
// import "./@fake-db"

const LazyApp = lazy(() => import("./App"))

const root = ReactDOM.createRoot(document.getElementById("root"));

// configureDatabase()
root.render(
    <Provider store={store}>
      <Suspense fallback={<Spinner />}>
        <Layout>
            <LazyApp />
        </Layout>
      </Suspense>
    </Provider>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
// serviceWorker.register()
